import { withInstall } from '@jdesign-vue/utils'

import Pagination from './src/pagination'

export const JdPagination = withInstall(Pagination)
export default JdPagination

export * from './src/pagination'
export * from './src/constants'
